import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { DataService } from './shared/dataservice.service';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { RoutingModule } from './routing/routing.module';
import { RtcDownloaderComponent } from './rtc-downloader/rtc-downloader.component';
import { HttpModule } from '@angular/http';
import { CookieModule } from 'ngx-cookie';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule, MatInputModule, MatSelectModule, MatRadioModule, 
         MatListModule, MatSnackBarModule ,MatDatepickerModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE,
         MatCheckboxModule, MatGridListModule} from '@angular/material';
import { MomentDateAdapter, MatMomentDateModule } from '@angular/material-moment-adapter';
import { RtcSerialNosComponent } from './rtc-serial-nos/rtc-serial-nos.component';
import { RtcUploaderComponent } from './rtc-uploader/rtc-uploader.component';

import { FileUploadModule } from 'ng2-file-upload';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { DrawingUploaderComponent } from './drawing-uploader/drawing-uploader.component';
import { DrawingDownloaderComponent } from './drawing-downloader/drawing-downloader.component';
import { DrawSoNosComponent } from './draw-so-nos/draw-so-nos.component';
import { DrawingDeleteComponent } from './drawing-delete/drawing-delete.component';
import { HelpDocComponent } from './help-doc/help-doc.component';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MMM DD, YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};



@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    RtcDownloaderComponent,
    RtcSerialNosComponent,
    RtcUploaderComponent,
    FileUploadComponent,
    DrawingUploaderComponent,
    DrawingDownloaderComponent,
    DrawSoNosComponent,
    DrawingDeleteComponent,
    HelpDocComponent,
    ],
  imports: [
    BrowserModule,
    RoutingModule,
    HttpModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatCheckboxModule,
    MatGridListModule,
    MatListModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    CookieModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    FileUploadModule
  ],
  providers: [DataService,
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
